import axios from 'axios'
import exceptionHandler from '@/common/exception-handler'

const validatePassword = (userId, password) => {
  return axios.post('/api/users/isValidNewPassword', { userId, password })
    .catch(error => exceptionHandler.parse(error))
}

export default {
  validatePassword
}
